import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-review-entry',
  templateUrl: './review-entry.component.html',
  standalone: true,
  styleUrls: ['./review-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewEntryComponent {
  @Input() label: string = '';
  @Input() value: string = '';
}
